module.exports = __webpack_public_path__ + "static/logo-black-b7c9d27b365b4007c101222c398a842b.svg";